import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// COMPONENT
import EngagementHistoryModal from './EngagementHistoryModal';
// API
import { getDoctorEnagagementHistory } from '../../../api/mdProfileApi';
// CONTEXT
import { useMdProfileContext } from '../context/useMdProfileContext';

export default function EngagementHistory({ modalFilterForm }) {
  const { viewProfile } = useContext(useMdProfileContext);

  const defaultDetailState = {
    toggle: false,
    loading: false,
    rep_id: '',
    year: '',
    row: {},
  };
  const [touchpointData, setTouchpointData] = useState({ loading: false, items: [] });
  const [detailState, setDetailState] = useState(defaultDetailState);

  const handleViewTouchpointDetail = (value) => {
    setDetailState({
      ...detailState,
      toggle: true,
      loading: false,
      rep_id: modalFilterForm?.rep_id?.value,
      year: modalFilterForm?.year,
      row: value,
    });
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Touchpoint',
      width: 400,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Typography variant='body1'>{row.name}</Typography>

          {row?.is_viewable ? (
            <IconButton aria-label='open Detail'>
              <OpenInNewIcon onClick={() => handleViewTouchpointDetail(row)} />
            </IconButton>
          ) : (
            ''
          )}
        </Box>
      ),
    },
    {
      field: 'Jan',
      headerName: 'Jan',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Feb',
      headerName: 'Feb',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Mar',
      headerName: 'Mar',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Apr',
      headerName: 'Apr',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'May',
      headerName: 'May',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Jun',
      headerName: 'Jun',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Jul',
      headerName: 'Jul',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Aug',
      headerName: 'Aug',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Sep',
      headerName: 'Sep',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Oct',
      headerName: 'Oct',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Nov',
      headerName: 'Nov',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'Dec',
      headerName: 'Dec',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
  ];

  const handleTouchpoint = async () => {
    setTouchpointData({ ...touchpointData, loading: true });

    const requuest = {
      basic_info_profile_id: viewProfile?.doctor_id,
      rep_id: modalFilterForm?.rep_id?.value,
      year: modalFilterForm?.year,
    };

    const response = await getDoctorEnagagementHistory(requuest);
    const { code, data } = response.data;

    if (code === '200') {
      setTouchpointData({ ...touchpointData, loading: false, items: data });
    }
  };

  useEffect(() => {
    handleTouchpoint();
  }, [modalFilterForm]);
  return (
    <Box
      className='table-container'
      sx={{
        height: `800px`,
        '& .super-app-theme--header': {
          fontWeight: 'bold',
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },
        '& .is_hdr': {
          backgroundColor: '#d4edf7ff' /* White for odd rows */,
        },
      }}
    >
      <DataGridPro
        loading={touchpointData?.loading}
        rows={touchpointData?.items}
        columns={columns}
        initialState={{
          ...touchpointData?.items?.initialState,
          pagination: {
            pageSize: 50,
          },
        }}
        rowsPerPageOptions={[25, 50, 100]}
        pagination
        getRowClassName={({ row }) => {
          return row.is_header ? 'is_hdr' : 'is_dtl';
        }}
      />

      {detailState?.toggle ? (
        <EngagementHistoryModal
          detailState={detailState}
          setDetailState={setDetailState}
          defaultDetailState={defaultDetailState}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
